import React, { useState } from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useLocation } from "react-router-dom";
import Header from "./header";
import DoctorPersonalDetails from "./personalDetailsForm";
import DoctorPracticeForm from "./doctorPracticeForm";
import SucessPopup from "./successPage";
import Term from "../../page/term&condition/term";
import { toggleState } from "../../specialMethod/toggleState";
import docAid from "../../../assets/doc-aid.png";

const RegisterDoctor = () => {
  const [state, setState] = useState({
    currentPage: 1,
    showNewComponent: false,
  });
  const location = useLocation();
  const varifyEmail = location.state?.getEmail || "";

  const [formData, setFormData] = useState({
    imageUpload: null,
    firstName: "Dr.",
    lastName: "",
    contact: "",
    email: varifyEmail || "",
    password: "",
    confirm_Password: "",
    doctors: [{ degree: "", college: "", year: "" }],
    specialization: [""],
    achievements: [""],
    experience: "",
    licenceNumber: "",
    research_journal: [""],
    citations: [""],
    referral: "",
  });

  const nextPage = (values) => {
    setFormData((prevData) => ({ ...prevData, ...values }));
    toggleState("currentPage", state.currentPage + 1, setState);
  };

  const previousPage = (values) => {
    setFormData((prevData) => ({ ...prevData, ...values }));
    toggleState("currentPage", state.currentPage - 1, setState);
  };

  const handleTermPage = () => {
    toggleState("showNewComponent", true, setState);
  };

  return (
    <div className="bg-gray-200 pt-2 lg:pt-10">
      <img src={docAid} alt="docaid" className="h-16 w-auto mx-auto" />
      {state.showNewComponent ? (
        <Term formData={formData} varifyEmail={varifyEmail} />
      ) : (
        <>
          {state.currentPage === 1 && (
            <DoctorPersonalDetails
              onNext={nextPage}
              formData={formData}
              setFormData={setFormData}
            />
          )}
          {state.currentPage === 2 && (
            <DoctorPracticeForm
              onNext={nextPage}
              onPrev={previousPage}
              formData={formData}
            />
          )}
          {state.currentPage === 3 && (
            <SucessPopup
              onSubmit={handleTermPage}
              onPrev={previousPage}
              formData={formData}
              imageData={formData.imageUpload}
            />
          )}
          <ToastContainer />
        </>
      )}
    </div>
  );
};

export default RegisterDoctor;